import { useQuery } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import { handleGetLatestWinners } from "../../api-clients/tournamentsExternalsClient";

const DEFAULT_WINNERS_REFETCH_INTERVAL = 30000;

export default function useLatestWinnersQuery(
  refetchInterval = DEFAULT_WINNERS_REFETCH_INTERVAL
) {
  const query = useQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.LATEST_WINNERS],
    queryFn: async () => (await handleGetLatestWinners()) ?? null,
    refetchInterval,
  });

  return {
    query,
    latestWinners: query.data ?? undefined,
  };
}
